// Odstavenie zariadenia for operational log entries (prevádzkový denník)
// Keep in sync with server/config/shutdownStatuses.js
export const SHUTDOWN_STATUSES = {
    NONE: 'NONE',
    PARTIAL: 'PARTIAL',
    FULL: 'FULL',
};

export const SHUTDOWN_STATUS_LABELS = {
    NONE: 'Nebolo odstavené',
    PARTIAL: 'Odstavené na časť dňa',
    FULL: 'Odstavené na celý deň',
};

export const SHUTDOWN_STATUS_OPTIONS = Object.entries(SHUTDOWN_STATUS_LABELS).map(([value, label]) => ({ value, label }));
